import { clsx } from 'clsx'
import { Button, ButtonLink } from '~/sotano-kit/primitives/button'

type LinkProps = React.HTMLAttributes<HTMLAnchorElement> & {
  icon: React.ReactNode
  href: string
}
type ButtonProps = React.HTMLAttributes<HTMLButtonElement> & {
  icon: React.ReactNode
}

type ExpandButtonProps = ButtonProps | LinkProps

const isButtonLink = (props: ExpandButtonProps): props is LinkProps => {
  return 'href' in props
}

export const ExpandButton = (props: ExpandButtonProps) => {
  if (isButtonLink(props)) {
    const { children, className, icon, href, ...rest } = props
    return (
      <ButtonLink
        unstyled
        icon={icon}
        focusStyled={false}
        iconSide="right"
        href={href}
        className={clsx(
          'py-1 leading-none border-b inline-flex w-min whitespace-nowrap items-center border-dark-faint gap-1 text-xs text-dark-muted hover:text-dark-bright focus-visible:outline focus-visible:outline-dark-faint focus-visible:outline-offset-2 focus-visible:outline-offset-dark-faint cursor-default',
          className
        )}
        {...rest}
      >
        {children}
      </ButtonLink>
    )
  }
  const { children, icon, className, ...rest } = props
  return (
    <Button
      unstyled
      icon={icon}
      focusStyled={false}
      iconSide="right"
      className={clsx(
        'py-1 leading-none border-b inline-flex w-min whitespace-nowrap items-center border-dark-faint gap-1 text-xs text-dark-muted hover:text-dark-bright focus-visible:outline focus-visible:outline-dark-faint focus-visible:outline-offset-2 focus-visible:outline-offset-dark-faint cursor-default',
        className
      )}
      {...rest}
    >
      {children}
    </Button>
  )
}
